export default __webpack_public_path__ + "static/bar-e383b4fcc0108ca78d4a2ee43309ff9f.webp";